module.exports = __webpack_public_path__ + "static/media/childrens-pool.69cd837a.svg";